import { apiInitState, reducerApiConstructor } from "../helpers";

const apiReducers = reducerApiConstructor("calendar");

export const calendarInitState = {
  init: false,
  events: [],
};

export const calendarReducers = {
  init: (state, action) => {
    state.init = true;
  },

  setMainEvents: (state, action) => {
    const { events } = action.payload;

    state.events = events;
  },

  getMainEvents: (state, action) => {},

  ...apiReducers,
};
